import React from 'react';



type Props = {
  className?: string;
}
export const ToolbarHomeVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '2' d = 'M22 21H3V9L12 3L21 9V18'/>
      <path stroke = 'currentColor' strokeWidth = '2' d = 'M9 22V15L15 15V22'/>
    </svg>
  );
};
